export function generateUID() {
  // I generate the UID from two parts here
  // to ensure the random number provide enough bits.
  const firstPartNumber = (Math.random() * 46656) | 0;
  const secondPartNumber = (Math.random() * 46656) | 0;
  const firstPartString = `000${firstPartNumber.toString(36)}`.slice(-3);
  const secondPartString = `000${secondPartNumber.toString(36)}`.slice(-3);
  return (firstPartString + secondPartString).toUpperCase();
}



// WEBPACK FOOTER //
// ./src/utils/generateUid.ts